$.fn.isOnScreen = function () {
    let win      = $(window),
        viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        },
        bounds   = this.offset();

    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top - 40 > bounds.bottom)); // -40 hack is important
};


/*
    The returned value is an empty string if the style is not found on the element.
    Else, it's a string representing the actual value (example: "150px" or "blue" or "none").

 */

$.fn.inlineStyle = function (prop) {
    return this.prop('style')[$.camelCase(prop)];
};



// WEBPACK FOOTER //
// ./src/js/helpers/plugins.js